import { Modal } from './components/Modal';
import './styles/global.css';

export function App() {
  return (
    <div className="bg-zinc-900 h-screen w-full">
      <Modal />
    </div>
  );
}
